<template>
  <main>
    <h4><strong>Login</strong></h4>
    <p>
      <button v-if="!$auth.isAuthenticated" 
        @click="$auth.loginWithRedirect"
        class="waves-effect waves-light btn-large orange accent-4">
          <i class="fab fa-slack-hash" />
          &nbsp;Log in with Fool.com
      </button>
    </p>
    <aside>
      <p>Please click the Slack button above to log in</p>
    </aside>
  </main>
</template>

<script>
export default {

};
</script>
